import React from 'react';
import { TextField, useFieldHelper, FieldProps } from 'framework/ui/field';
import { BUDGET_STRUCTURE_STATUS } from 'domain/shared/newProject';

const SignBox = ({ children }: { children: React.ReactNode }) => (
  <span style={{ display: 'inline-block', width: '1em', textAlign: 'center' }}>{children}</span>
);

const BudgetHoursField = ({ source, status, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const { getValue: getStatus } = useFieldHelper({ source: status });

  const formatHours = (value: string | number) => {
    if (!value && value !== 0) return '—';
    const num = Number(value);
    return (
      <>
        <SignBox>{num < 0 ? '-' : '+'}</SignBox>
        {Math.abs(num)} h
      </>
    );
  };

  if (getStatus() === BUDGET_STRUCTURE_STATUS.CLOSED) {
    return <TextField {...props} value="—" />;
  }

  return <TextField {...props} value={formatHours(getValue())} />;
};
export default BudgetHoursField;
